(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt-Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips}`;
  }

  // Raspberry
  window.adConfigs['retargeting-craving-raspberry'] = {
    subline1: 'Indulge unapologetically',
    subline2: buildFlavourChips('Raspberry'),
    cartSub:  buildFlavourList('Raspberry'),
    image:    null,
  };

  // Caramel
  window.adConfigs['retargeting-craving-caramel'] = {
    subline1: 'Go on',
    subline2: buildFlavourChips('Caramel'),
    cartSub:  buildFlavourList('Caramel'),
    image:    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Caramel-PDP.jpg?v=1775654171',
  };

  // Mixed Box
  const mixedChips = flavours.map((f, i) =>
    `<span class="bb-flavour-chip">${f}</span>${i < flavours.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
  ).join('');

  window.adConfigs['retargeting-craving-mixedbox'] = {
    subline1: 'Indulge unapologetically',
    subline2: `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${mixedChips}`,
    cartSub:  'Six bars: ' + flavours.join(' · '),
    image:    null,
  };

})();